// leaflet-rotate patches the global L, so Leaflet must be evaluated before it.
// sort-imports puts side-effect imports first, hence the second import of leaflet.
/* eslint-disable import/no-duplicates */
import "leaflet";
import "leaflet-rotate";
import L from "leaflet";
/* eslint-enable import/no-duplicates */
import _ from "lodash";

// Delay after the last rotate event before the vector renderers catch up
const RENDERER_ROTATE_DELAY = 150;

// leaflet-rotate updates every renderer on each "rotate" event, which re-clips
// and rewrites the path of every feature: with 18k plots each wheel step or
// dial move blocks the main thread for hundreds of ms. While rotating, the SVG
// already turns with its pane, so update it once the gesture stops.
// ponytail: edges of the vector layer may look clipped while rotating, raise
// the renderer padding if it shows
const rotateRendererEvents = L.Renderer.prototype.getEvents;

L.Renderer.include({
  getEvents() {
    const events = rotateRendererEvents.call(this);
    this._onRotateEnd ||= _.debounce(
      () => this._map && this._update(),
      RENDERER_ROTATE_DELAY
    );
    return { ...events, rotate: this._onRotateEnd };
  },
});

// leaflet-rotate does not rotate the maxBounds drag limit: built from two
// rotated corners, it throws the first move thousands of km away around 45°.
// The limit only holds north-up, so drop it while the map is rotated.
const dragStart = L.Map.Drag.prototype._onDragStart;

L.Map.Drag.include({
  _onDragStart() {
    dragStart.call(this);
    if (this._map.getBearing()) this._offsetLimit = null;
  },
});
